import { FNOLWindshield } from '../../../../../../pages/FNOL'

export default [
  {
    is: { windshield: 'windshieldStart' },
    page: FNOLWindshield,
  },
]
